import React from 'react';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useWorkflowTabs } from '../../WorkflowTabs/useWorkflowTabs';
import TreeLayout from './TreeLayout/TreeLayout';
import style from './WorkflowCanvasWithLayout.module.scss';

const DISABLE_PANNING_CLASS = 'c';

const WorkflowCanvasWithLayout = () => {
  const { selectedTab } = useWorkflowTabs();
  if (!(selectedTab === 0 || selectedTab === 1)) {
    return null;
  }
  return (
    <TransformWrapper
      minScale={0.5}
      maxScale={2}
      centerZoomedOut={true}
      smooth={true}
      panning={{
        excluded: [DISABLE_PANNING_CLASS],
        velocityDisabled: true,
      }}
      pinch={{ excluded: [DISABLE_PANNING_CLASS] }}
      velocityAnimation={{
        disabled: true,
      }}
      doubleClick={{
        disabled: true,
        excluded: [DISABLE_PANNING_CLASS],
      }}
      disablePadding={false}
    >
      <TransformComponent
        wrapperClass={style.container}
        contentStyle={{
          transformStyle: 'preserve-3d',
          willChange: 'transform',
        }}
      >
        <TreeLayout />
      </TransformComponent>
    </TransformWrapper>
  );
};

export default WorkflowCanvasWithLayout;
